var profile = {
	selectors: { },

	init: function () {
		var self = this;

        self.fillForm();
        self.resetForm();
        self.checkAccountFilled();
        self.usernamechanger();
       // self.checkPushAlertUserId();

       self.newProfileByOrder();

       self.tax_type_checker();
	},

    tax_type_checker: function() {
        const taxTypeSelect = document.querySelector('select[name="tax_type"]');
        
        function updateFieldVisibility() {
            // Všechny divy s potřebnými atributy pomocí :has()
            const icoDiv = document.querySelector('.full-width:has([data-name="billing_ico"])');
            const dicDiv = document.querySelector('.full-width:has([data-name="billing_dic"])');

            const icoInput = document.querySelector('[name="billing_ico"]');
            const dicInput = document.querySelector('[name="billing_dic"]');
            
            // Skryjeme všechny divy jako výchozí stav
            if (icoDiv) icoDiv.style.display = 'none';
            if (dicDiv) dicDiv.style.display = 'none';
            
            // Hodnoty, které nezobrazují žádné pole
            const hideAllValues = [
                '', // Prázdná hodnota
                'Fyzická osoba (Nepodnikatel)' // Fyzická osoba
            ];
            
            // Hodnoty, které zobrazují pouze IČO
            const icoOnlyValues = [
                'OSVČ - Neplátce DPH'
            ];
            
            // Hodnoty, které zobrazují IČO i DIČ
            const bothFieldsValues = [
                'OSVČ - Plátce DPH', 
                'Právnická osoba (s.r.o.) – Plátce DPH'
            ];
            
            // Aktuální vybraná hodnota
            const selectedValue = taxTypeSelect.value;
            
            // Logika zobrazování
            if (hideAllValues.includes(selectedValue)) {
                // Skryto vše (už je nastaveno výchozím stavem)
               // return;
            }
            
            if (icoOnlyValues.includes(selectedValue)) {
                // Zobrazit jen IČO
                if (icoDiv) icoDiv.style.display = 'block';
            }
            
            if (bothFieldsValues.includes(selectedValue)) {
                // Zobrazit IČO i DIČ
                if (icoDiv) icoDiv.style.display = 'block';
                if (dicDiv) dicDiv.style.display = 'block';
            }

            // IČO
            if (icoDiv && icoInput) {
                console.log("asdas");
                console.log(icoDiv.style.display);
                console.log(icoInput);
                if (icoDiv.style.display === 'none') {
                    // Pokud je pole skryté a prázdné, doplníme pomlčku
                    if (!icoInput.value) {
                        icoInput.value = '-';
                        console.log("vyplň pomlčku");
                    }
                } else {
                    // Pokud je pole viditelné a obsahuje jen pomlčku, vymažeme ji
                    if (icoInput.value === '-') {
                        icoInput.value = '';
                        console.log("vymaž pomlčku");
                    }
                }
            }

            // DIČ
            if (dicDiv && dicInput) {
                if (dicDiv.style.display === 'none') {
                    if (!dicInput.value) {
                        dicInput.value = '-';
                    }
                } else {
                    if (dicInput.value === '-') {
                        dicInput.value = '';
                    }
                }
            }
        }

        if (!taxTypeSelect) {
            return;
        }
        
        // Přidáme event listener na změnu selectu
        taxTypeSelect.addEventListener('change', updateFieldVisibility);
        
        // Zavoláme funkci ihned při načtení stránky, aby se nastavilo správné počáteční zobrazení
        updateFieldVisibility();
    },

	usernamechanger: function() {
		if( ! jQuery( '[name="artist_url_name"]' ) ) {
			return false;
		}

		jQuery( '[name="artist_url_name"]' ).on( 'keyup', function(){
			jQuery( '[name="change_user_name"]' ).addClass( 'disabled' );

			if( jQuery(this).val().length <= 4 ) {
				jQuery( '[data-aunresponse]' ).text( 'Minimální délka je 5 znaků.' );
				//jQuery( '[data-aunresponse]' ).removeClass( 'd-none' );
				return false;
			}

			//jQuery( '[data-aunresponse]' ).addClass( 'd-none' );
			jQuery( '[data-aunresponse]' ).text( '' );

			let formData = new FormData();
			formData.append( 'action', 'check_form_namechange' );
			formData.append( 'nonce', sikmoVars.nonce );
			formData.append( 'artist_url_name', jQuery( this ).val() );

			fetch( sikmoVars.ajax_url, {
				method: 'POST',
				credentials: 'same-origin', 
				body: formData
			})
			.then( response => response.json() )
			.then( response => {
				//jQuery( '[data-aunresponse]' ).removeClass( 'd-none' );
				jQuery( '[data-aunresponse]' ).text( response.data.message );

				if( ! response.success ) {
					return false;
				}

				jQuery( '[name="change_user_name"]' ).removeClass( 'disabled' );
			})
			.catch( error => console.error('Error:', error)) ;
		});
		
		jQuery( '[name="change_user_name"]' ).on( 'click', function(){
			if( jQuery( '[name="artist_url_name"]' ).val().length <= 4 ) {
				jQuery( '[data-aunresponse]' ).text( 'Minimální délka je 5 znaků.' );
				//jQuery( '[data-aunresponse]' ).removeClass( 'd-none' );
				return false;
			}

			//jQuery( '[data-aunresponse]' ).addClass( 'd-none' );
			jQuery( '[data-aunresponse]' ).text( '' );

			let formData = new FormData();
			formData.append( 'action', 'maybe_change_user_login' );
			formData.append( 'nonce', sikmoVars.nonce );
			formData.append( 'artist_url_name', jQuery( '[name="artist_url_name"]' ).val() );

			fetch( sikmoVars.ajax_url, {
				method: 'POST',
				credentials: 'same-origin', 
				body: formData
			})
			.then( response => response.json() )
			.then( response => {
				if( ! response.success ) {
				//	jQuery( '[data-aunresponse]' ).removeClass( 'd-none' );
					jQuery( '[data-aunresponse]' ).text( response.data.message );

					return false;
				}

				window.location.href = response.data.message;
			})
			.catch( error => console.error('Error:', error)) ;
		});
	},

    checkPushAlertUserId: function(){

        (pushalertbyiw = window.pushalertbyiw || []).push(['onReady', onPAReady]);

        function onPAReady() {
            //console.log( PushAlertCo.subs_id ); //if empty then user is not subscribed
    
            if(  sikmoVars.pushalert_user_id != PushAlertCo.subs_id && sikmoVars.pushalert_user_id !== 'not-logged-in' && PushAlertCo.subs_id !== '' ) {
                let formData = new FormData();
                formData.append( 'action', 'save_pushalert_user_id' );
                formData.append( 'nonce', sikmoVars.nonce );
                formData.append( 'pushalert_user_id',  PushAlertCo.subs_id );
    
                fetch( sikmoVars.ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin', 
                    body: formData
                })
                .then( response => response.json() )
                .then( data => {
                    console.log(data);
                })
                .catch( error => console.error('Error:', error)) ;
            }
        }

        // (pushalertbyiw = window.pushalertbyiw || []).push(['onReady', onPAReady]);
       
		// function onPAReady() {
        //     console.log( sikmoVars.pushalert_user_id );
        //     console.log("ghede");
        //     console.log("js");
        //     let subs_info = PushAlertCo.getSubsInfo();
        //     if(  sikmoVars.pushalert_user_id != subs_info.subs_id && sikmoVars.pushalert_user_id !== 'not-logged-in' ) {
        //         let formData = new FormData();
        //         formData.append( 'action', 'save_pushalert_user_id' );
        //         formData.append( 'nonce', sikmoVars.nonce );
        //         formData.append( 'pushalert_user_id',  subs_info.subs_id );

        //         fetch( sikmoVars.ajax_url, {
        //             method: 'POST',
        //             credentials: 'same-origin', 
        //             body: formData
        //         })
        //         .then( response => response.json() )
        //         .then( data => {
        //             console.log(data);
        //         })
        //         .catch( error => console.error('Error:', error)) ;
        //     }
		// }
        
    },


    newProfileByOrder: function() {
        jQuery(document).ready(function($) {
            jQuery('.js-paygopay').click(function(e) {
                var basic_agree = jQuery('[name="basic_agree"]').is(':checked') ? jQuery('[name="basic_agree"]').val() : 0;
                var email_agree = jQuery('[name="email_agree"]').is(':checked') ? jQuery('[name="email_agree"]').val() : 0;

                if( jQuery('[name="basic_agree"]').length ) {         
                    if( basic_agree == 0 ) {
                        e.preventDefault();
                    }
                }
            
                var data = {
                    'action': 'update_user_agreements',
                    'basic_agree': basic_agree,
                    'email_agree': email_agree,
                    
                };
        
                jQuery.post(sikmoVars.ajax_url, data, function(response) {console.log(response);});
            });

            jQuery('[name="basic_agree"]').change(function(e) {
                if( jQuery('[name="basic_agree"]').is(':checked')) {
                    jQuery('.js-paygopay').removeClass( "disabled" );
                }   
                else {
                    jQuery('.js-paygopay').addClass( "disabled" );
                }             

            });
        });
    },

    checkAccountFilled: function() {
        if( document.querySelector(".js-fillAccount") ) {
            document.querySelector(".wpcf7-form").classList.add("account-not-filled");
        }
    },

    fillForm: function() {

        self = this;

        const formParent = document.querySelector('div[data-inputs]');
        if( !formParent ) { return false; }

        // Get the JSON string from the data-attribute
        const jsonData = formParent.getAttribute('data-inputs');

        // Parse the JSON string
        let inputsArray = JSON.parse( jsonData );

        // Iterate over the array and set the input values
        Object.entries(inputsArray).forEach(([key, value]) => {
            if( key == "start-time" ) {
                formParent.querySelector(`input[name="${key}"]`).closest(".js-fakeTimeForm").querySelector("[type='time']").value = value;
            }
            if( key == "end-time" ) {
                formParent.querySelector(`input[name="${key}"]`).closest(".js-fakeTimeForm").querySelector("[type='time']").value = value;
            }
            if( key == "tax_type" && value != null ) {   
               formParent.querySelector(`select[name="${key}"]`).setAttribute("readonly", "readonly");
            }

            const radioButtons = formParent.querySelectorAll(`input[name="${key}"][type="radio"]`);
            const checkButtons = formParent.querySelectorAll(`input[name="${key}[]"][type="checkbox"]`);
            if (radioButtons.length > 0) {
                radioButtons.forEach(radio => {
                    if (radio.value === value) {
                        radio.checked = true;
                    }
                });
            }
            else if (checkButtons.length > 0) {
                checkButtons.forEach(checkbox => {
                    if( key == "free" && value == "1") {checkbox.checked = true;}

                    if (checkbox.value === value) {
                        checkbox.checked = true;
                    }
                });
            } else {
                const input = formParent.querySelector(`[name="${key}"]`);

                if (input) {
                    if( value != "" && value != null) {
                        if( input.closest(".plus-minus-input") ) {
                            const after = input.closest(".plus-minus-input").getAttribute( "data-after" );
                            input.value = value + after;
                        }
                        else {
                            input.value = value;
                        }  

                        // if( value == null ) {
                        //     input.value  = parseInt(  input.closest(".plus-minus-input").getAttribute( "data-min" ) );
                        
                        // }
                    }

                    
                }
            }
        });
        self.tax_type_checker();
	},

    resetForm: function() {
        const resetForm = document.querySelector('.js-reloadForm');

		let self = this;

        if( !resetForm ) {  return; }

        resetForm.addEventListener('click', (e) => {
            e.preventDefault();
        
            self.fillForm();
        });
	},
};

export { profile };


